import React from 'react';
import PropTypes from 'prop-types';

import { ChipsItem, Label } from '@atlas/ui';

const CasinoLoadMoreButton = ({ handleClick }) => {
  return (
    <div className="casino-load-more-block">
      <ChipsItem
        className="casino-load-more-button"
        label={<Label message="casino_load_more_games" />}
        onClick={handleClick}
      />
    </div>
  );
};

CasinoLoadMoreButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
};

export default CasinoLoadMoreButton;
